import './style/index.js';

import _BackTop from './BackTop';

export type { BackTopProps } from './BackTop';

export const BackTop = _BackTop;

export default BackTop;
